const scales = {
    null: '0',
    0.0625: '1px',
    0.125: '2px',
    0.25: '4px',
    0.5: '8px',
    0.75: '12px',
    1: '16px',
    1.5: '24px',
    2: '32px',
    2.5: '40px',
    3: '48px',
    4: '64px',
    8: '128px',
    16: '256px'
};
export default scales;

//# sourceMappingURL=scales.js.map